<template>
  <div style="width: 100%; height: 804px">
    <el-amap
      v-if="showMap"
      class="amap-box"
      ref="amap"
      vid="amap-vue"
      :center="center"
      :zoom="zoom"
    >
      <div
        :key="idx"
        v-for="(item, idx) in polygonlistOne"
        v-if="polygonlistOne.length"
      >
        <el-amap-polygon
          v-bind="polygonConfig"
          :path="item.path"
        ></el-amap-polygon>
      </div>
    </el-amap>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
import { getPointGeoJson } from "@/api/point.js";
Vue.use(VueAMap);

export default {
  name: "AMap",
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      showMap: false,
      amap: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值

      zoom: 14,
      center: [116.334529, 39.979991],
      // 绘制边界
      polygonConfig: {
        // 城市边界 配置
        strokeColor: "#5D87FB", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#5D87FB", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygonlistOne: [],
      wgList: []
    };
  },
  created() {
    this.showMap = false;
  },
  mounted() {
    this.$nextTick(() => {
      this.showMap = true;
      this.init();
    });
  },
  beforeDestroy() {
    this.showMap = false;
    this.amap = null;
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          "AMap.GeoJSON",
          "AMap.Heatmap"
        ],
        // 高德 sdk 版本
        v: "1.4.15"
      });
      setTimeout(async () => {
        _self.amap = _self.$refs.amap.$$getInstance();
        _self.getPointGeoJsonFun();
      }, 1000);
    },

    // 获取网格数据
    async getPointGeoJsonFun() {
      this.polygonlistOne = [];
      let params = {
        needGeoJson: true,
        levelCode: 3,
        pointName: this.pointInfo.levelCode == 1 ? "" : this.pointInfo.pointName
      };
      const res = await getPointGeoJson(params);
      this.wgList = res.data.data.pointGeoJsonList || [];
      if (this.pointInfo.levelCode == 1) {
        this.zoom = 15;
        // this.$refs.amap.$$getInstance().setZoom(14.4);
      }
      if (this.pointInfo.levelCode == 2) {
        this.zoom = 16;
      }
      if (this.pointInfo.levelCode == 3) {
        this.zoom = 17;
      }
      console.log(this.zoom, "zoom");

      if (this.wgList.length) this.addGeo();
    },
    addGeo() {
      if (
        this.wgList[0].pointLongitude != -1 &&
        this.wgList[0].pointLatitude != -1
      )
        this.center = [
          this.wgList[0].pointLongitude,
          this.wgList[0].pointLatitude
        ];
      this.wgList.forEach(itm => {
        if (itm.geoJson) {
          let geoJson = JSON.parse(itm.geoJson);
          geoJson.features.forEach(item => {
            if (item.geometry.coordinates && item.geometry.coordinates.length) {
              this.polygonlistOne.push({
                path: item.geometry.coordinates,
                ...itm,
                center: [itm.pointLongitude, itm.pointLatitude],
                position: [itm.pointLongitude, itm.pointLatitude]
              });
            }
          });
        }
      });
    }
  },
  watch: {
    pointInfo: {
      deep: true,
      handler(val) {
        let _self = this;
        setTimeout(async () => {
          _self.amap = _self.$refs.amap.$$getInstance();
          _self.getPointGeoJsonFun();
        }, 1000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.amap-box {
  width: 100%;
  min-height: 505px;
}
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}
.point {
  width: 300px;
  padding: 10px 24px;
  background: #fff;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: #494c4f;
  box-shadow: 0px 2px 4px 0px rgba(22, 54, 79, 0.08);
  border-radius: 33px;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/motherChildPoint/components/map.vue